module.exports = __webpack_public_path__ + "img/report_banner@2x.b56c4932.jpg";